<template>
  <div class="container-comment">
    <div class="header-comment">
      <h4>Comments - Ref {{cReference}}</h4>
      <span @click="close()">x</span>
    </div>
    <div class="body-comment">
      {{cMessage}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal-comment',
  methods: {
    close() {
      this.$store.commit('CLOSE_COMMENT');
    },
  },
  computed: {
    cMessage() {
      return this.$store.getters.messageComment;
    },
    cReference() {
      if (this.$store.getters.reference) {
        return this.$store.getters.reference;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.container-comment {
  position: fixed;
  right: 0;
  bottom: 0;
  margin-right: 25vw;
  width: 414px;
  max-height: 297px;
  padding: 24px 17px;
  background: #ffffff;
  box-shadow: 0px 0px 7px rgba(48, 48, 48, 0.3);
  border-radius: 5px 5px 0px 0px;
  z-index: 10;
  margin-bottom: 1px;
  @media (max-width: 960px) {
    width: 92.4vw;
    margin-right: 0;
    left: 0;
    margin: 0 auto;
  }
  .header-comment {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 37px;
    width: 100%;
    h4 {
      text-align: left;
      font-weight: 500;
      font-size: 13px;
      letter-spacing: 0.274837px;
      color: $header;
    }
    span {
      font-size: 26px;
      cursor: pointer;
      padding: 5px;
      color: $dataTable;
    }
    &:after {
      content: "";
      position: absolute;
      width: 88px;
      height: 6px;
      background-color: $backgroundData;
      border-radius: 65px;
      top: -10px;
      left: 143px;
    }
  }
  .body-comment {
    width: 100%;
    margin-top: 19px;
    max-height: 186px;
    border-radius: 2px;
    background-color: $backgroundComment;
    text-align: left;
    padding: 27px 12px;
    font-weight: 500;
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 0.274837px;
    color: $header;
    word-break: break-word;
    overflow-y: auto;
  }
}
</style>
